const colors = {
    red: '#FB6559',
    orange: '#FB9359',
    yellow: '#FBD759',
    lightGreen: '#8BC117',
    skyBlue: '#59A3FB',
    blue: '#5973FB',
    purple: '#8D59FB',
    pink: '#D159FB',
    lightGray: '#D9D9D9',
    darkGray: '#2D2D2D',
    black: '#000',
    white: '#fff',
};

const fontSize = {
    xs: '1.4rem',
    small: '1.6rem',
    base: '1.8rem',
    medium: '2rem',
    large: '2.6rem',
    xl: '3rem',
    xxl: '4rem',
};

const theme = {
    colors,
    fontSize,
};

export default theme;
